import { Injectable } from '@angular/core';
import { FiUserDataService } from '../fi-shared-services/fi-user-data.service';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';

@Injectable()
export class FiAuthChangeLoginService {
    constructor(
        private userDataService: FiUserDataService,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
    ) {
        this.userDataService.onUserDataChanged$.subscribe((userData) => {
            if (userData) {
                if (userData.SignInUpdateData?.IsSendSignInUpdateEmailFailed) {
                    const message = `
                        <p>${this.appTextService.get('login.signin_update_text2')}:
                        <span class="BrandedColor">${this.userDataService.userData.LoginName}</span>.</p>
                        <p>${this.appTextService.get('login.signin_update_text3')}</p>
                        <p>${this.appTextService.get('login.signin_update_text4')}</p>
                    `;

                    this.fiDialogsService.confirm({
                        headerText: this.appTextService.get('login.signin_update_title'),
                        headerIconClass: 'BrandedColor fa-regular fa-circle-exclamation',
                        messageText: message,
                        yesButtonText: this.appTextService.get('ok'),
                        isNoButtonHidden: true,
                    });
                }
            }
        });
    }

    init() {}
}
